var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShares(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_236_5668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6259 18.627 23.9981 11.9971 23.999C5.37206 23.999 -0.000959639 18.6259 5.14575e-07 11.999C-0.00191979 5.37216 5.3711 0 11.999 0C18.627 0 24 5.37312 24 12Z",
    fill: "#2AFF07",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2133 12.5001H14C12.34 12.5001 11.5 11.5601 11.5 9.70006V7.78672C11.5 7.10672 11.58 6.13339 12.2867 5.60006C12.88 5.16006 13.7333 5.12672 14.9933 5.49339C16.6467 5.97339 18.0267 7.35339 18.5067 9.00672C18.8733 10.2601 18.84 11.1201 18.4 11.7067C17.8667 12.4201 16.8933 12.5001 16.2133 12.5001ZM13.52 6.24006C13.2467 6.24006 13.0333 6.29339 12.8933 6.40006C12.6333 6.59339 12.5067 7.04672 12.5067 7.78672V9.70672C12.5067 11.2001 13.08 11.5067 14.0067 11.5067H16.22C16.9533 11.5067 17.4067 11.3801 17.6067 11.1201C17.84 10.8134 17.82 10.2001 17.56 9.30006C17.1733 7.98672 16.04 6.84672 14.7267 6.46672C14.2333 6.31339 13.8333 6.24006 13.52 6.24006Z",
    fill: "#27313D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.38 19.1667C11.0267 19.1667 10.6667 19.1401 10.3067 19.0801C7.58004 18.6401 5.36004 16.4267 4.92004 13.7001C4.35338 10.1934 6.61338 6.88672 10.0734 6.18005C10.3467 6.12672 10.6067 6.30005 10.6667 6.56672C10.72 6.84005 10.5467 7.10005 10.28 7.16005C7.35338 7.76005 5.43338 10.5601 5.92004 13.5401C6.29338 15.8467 8.16671 17.7201 10.4734 18.0934C13.4667 18.5734 16.26 16.6467 16.8534 13.7067C16.9067 13.4334 17.1734 13.2601 17.44 13.3134C17.7134 13.3667 17.8867 13.6334 17.8334 13.9001C17.2 17.0134 14.48 19.1667 11.38 19.1667Z",
    fill: "#27313D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_236_5668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShares);
export default __webpack_public_path__ + "static/media/shares.b7b2f58bded90dfd721788517140188b.svg";
export { ForwardRef as ReactComponent };